import React from 'react';
import { Link, StaticQuery, graphql } from 'gatsby';
import { Location } from '@reach/router';

import { categoryPermalink } from '../utils/categories';

import './Sidebar.css';

function Sidebar({ allMarkdownRemark: { group } }) {
  return (
    <aside className="sidebar">
      <Location>
        {({ location }) => (
          <ul className="sidebar__categories">
            {group
              .slice()
              .sort((a, b) => (a.fieldValue || '').localeCompare(b.fieldValue || ''))
              .map(({ fieldValue }) => {
              const route = categoryPermalink(fieldValue);
              const isCurrent = routesEqual(location.pathname, route);
              return (
                <li key={fieldValue} className={`sidebar__category${isCurrent ? ' m-current' : ''}`}>
                  <Link
                    to={isCurrent ? '/' : route}
                    className={`sidebar__link${isCurrent ? ' m-current' : ''}`}
                  >
                    {fieldValue}
                  </Link>
                </li>
              );
            })}
          </ul>
        )}
      </Location>
    </aside>
  );
}

export default () => (
  <StaticQuery
    query={graphql`
      query {
        allMarkdownRemark {
          group(field: frontmatter___categories) {
            fieldValue
          }
        }
      }
    `}
    render={Sidebar}
  />
);

function routesEqual(routeA, routeB) {
  if (!routeA || !routeB) return false;
  const normalize = r => decodeURIComponent(r).replace(/\/$/, '');
  const a = normalize(routeA);
  const b = normalize(routeB);
  // Use endsWith rather than indexOf to handle the /blog pathPrefix while
  // avoiding false matches like /category/auth matching /category/authentication
  return a === b || a.endsWith(b);
}
